import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class MigrationNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the applySimioV2Consents global action. */
    this.applySimioV2Consents = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "applySimioV2Consents",
      operationName: "applySimioV2Consents",
      operationReturnType: "MigrationApplySimioV2Consents",
      namespace: "migration",
      variables: {
        migrationId: { required: false, type: "String" },
        companyPhoneId: { required: false, type: "Float" },
        simioServerUrl: { required: false, type: "String" },
        simioApiKey: { required: false, type: "String" }
      }
    });
    /** Executes the migrateCustomerToSimioV2 global action. */
    this.migrateCustomerToSimioV2 = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "migrateCustomerToSimioV2",
      operationName: "migrateCustomerToSimioV2",
      operationReturnType: "MigrationMigrateCustomerToSimioV2",
      namespace: "migration",
      variables: {
        migrationId: { required: false, type: "String" },
        customerId: { required: false, type: "String" },
        simioServerUrl: { required: false, type: "String" },
        simioApiKey: { required: false, type: "String" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" },
        force: { required: false, type: "Boolean" },
        encryptedSimioApiKey: { required: false, type: "String" },
        queuedBatchNumber: { required: false, type: "Float" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "migration",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  MigrationNamespace
};
//# sourceMappingURL=migration.js.map
